<template>
  <div>
    <div class="font-weight-bold h5">
      Dodaj zajęcia
    </div>

    <div class="d-flex align-items-center justify-content-between">
      <div class="font-weight-bold pb-2 text-primary">
        {{ formattedDay }}
      </div>

      <ReportCheckbox
        v-model="multiDay"
        text="Wielodniowe"
      />
    </div>

    <div class="row">
      <div class="col-6">
        <div class="font-weight-bold text-left">
          Od
        </div>
        <BFormInput
          v-if="!multiDay"
          v-model="hourFrom"
          type="text"
          placeholder="HH:mm"
          :state="validateHour(hourFrom) ? null : false"
          @blur="updateHourFrom"
        />
        <CtkDateTimePicker
          v-else
          v-model="dateFrom"
          locale="pl"
          format="YYYY-MM-DD HH:mm"
          @update="dateFrom = $event"
        />
      </div>
      <div class="col-6">
        <div class="font-weight-bold text-left">
          Do
        </div>
        <BFormInput
          v-if="!multiDay"
          v-model="hourTo"
          type="text"
          placeholder="HH:mm"
          :state="validateHour(hourTo, hourFrom) ? null : false"
          @blur="updateHourTo"
        />
        <CtkDateTimePicker
          v-else
          v-model="dateTo"
          locale="pl"
          format="YYYY-MM-DD HH:mm"
          @update="dateTo = $event"
        />
      </div>
    </div>
    <div class="mt-2">
      <BFormTextarea
        v-model="description"
        placeholder="Komentarz"
      />
    </div>
    <hr>

    <ProductList
      :catalog-id="catalogId"
      :selected="[]"
      :selected-listings.sync="selectedListings"
      only-listings
      single-select
    />

    <hr>
    <div class="row">
      <div class="col-6">
        <button
          class="btn btn-secondary btn-block"
          @click="$emit('cancel')"
        >
          Anuluj
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary btn-block"
          :disabled="invalid"
          @click="save"
        >
          Zapisz
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/api/axios';
import ReportCheckbox from '@/components/reports/ReportCheckbox';
import ProductList from '@/pages/shop/order/ProductList';
import moment from 'moment';
import CtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
  props: {
    catalogId: String,
    initDay: String,
    initHour: Number,
  },
  data: () => ({
    multiDay: false,
    selectedListings: [],
    dateFrom: moment().format('YYYY-MM-DD HH:mm'),
    dateTo: moment().format('YYYY-MM-DD HH:mm'),
    hourFrom: '9:00',
    hourTo: '9:00',
    description: '',
  }),
  components: {
    ProductList,
    ReportCheckbox,
    CtkDateTimePicker,
  },
  computed: {
    formattedDay() {
      return moment(this.initDay).format('dddd, D MMMM YYYY');
    },
    invalid() {
      if (this.selectedListings.length === 0) {
        return true;
      }
      if (this.multiDay) {
        return !this.dateFrom || !this.dateTo;
      }
      return !this.validateHour(this.hourFrom) || !this.validateHour(this.hourTo, this.hourFrom);
    },
  },
  methods: {
    save() {
      if (this.selectedListings.length === 0) {
        return;
      }
      const from = this.multiDay
        ? this.dateFrom
        : moment(this.initDay).add(this.toMinutes(this.hourFrom), 'minutes').format();

      const to = this.multiDay
        ? this.dateTo
        : moment(this.initDay).add(this.toMinutes(this.hourTo), 'minutes').format();

      const offerId = this.selectedListings[0];

      axios.post(`/calendar/${this.catalogId}/events?offerId=${offerId}`, {
        offerId,
        from,
        to,
        description: this.description,
      });
    },
    validateHour(hour, afterTime) {
      const h = this.toMinutes(hour);
      if (h < 0) {
        return false;
      }
      if (afterTime) {
        return h >= this.toMinutes(afterTime);
      }

      return true;
    },
    toMinutes(time) {
      if (!time) {
        return -1;
      }

      const parts = time.split(':');
      if (parts.length !== 2) {
        return -1;
      }
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (Number.isNaN(hours) || hours > 23 || Number.isNaN(minutes) || minutes > 59) {
        return -1;
      }
      return hours * 60 + minutes;
    },
    formatAsTime(minutes) {
      const hour = Math.floor(minutes / 60).toString().padStart(2, '0');
      const minute = (minutes % 60).toString().padStart(2, '0');
      return `${hour}:${minute}`;
    },
    updateHourFrom() {
      const minutes = this.toMinutes(this.hourFrom);
      if (minutes < 0) {
        return;
      }

      this.hourFrom = this.formatAsTime(minutes);
    },
    updateHourTo() {
      const minutes = this.toMinutes(this.hourTo);
      if (minutes < 0) {
        return;
      }
      this.hourTo = this.formatAsTime(minutes);
    },
  },
  created() {
    this.hourFrom = `${this.initHour}:00`;
    this.hourTo = `${this.initHour + 1}:00`;
    this.dateFrom = moment(this.initDay).format('YYYY-MM-DD');
    this.dateTo = moment(this.initDay).format('YYYY-MM-DD');
    this.updateHourFrom();
    this.updateHourTo();
  },
};
</script>
